import { createContext } from 'preact/compat';
export const optionsDefaults = {
    formTitle: 'Direct Debit Details',
    formCopy: 'Your monthly subscription is by Direct Debit, your first month is by Payment Card. Please fill in the required Direct Debit details using the form below:',
    termsHeading: 'Terms & Conditions for recreational activities',
    termsSubheading: 'Please read the following and accept below:',
    termsContent: '',
    submissionUrl: '/submitTest.php',
    directDebitLogo: '/assets/images/directdebit.jpg',
    termsAndConditionsText: 'I have read and understood the important information above.',
    directDebitConditionsText: 'I confirm that I am the account holder and am authorised to set up Direct Debit payments on this account.',
    overviewTitle: undefined,
    initialPrice: '£100.00',
    initialPriceCopy: undefined,
    monthlyPrice: undefined,
    monthlyPriceCopy: undefined,
    overrideApiRoute: false,
};
export const DirectDebitFormCTX = createContext(optionsDefaults);
